import { doLogout } from 'actions/authAction'
import {
  BASE_URL,
} from './constant'

export const CRON_LOG_VIEW = "CRON_LOG_VIEW";

const getViewCron = (bool, data, status, message) => {
  return {
    type: CRON_LOG_VIEW,
    isLoad: bool,
    data,
    status,
    message,
  };
};

export function cronGetView(data) {
  return (dispatch) => {
    dispatch(getViewCron(true, {}, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body:JSON.stringify(data)
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `activity/cron-activity`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(getViewCron(false, value, false, ""));
        } else {
          dispatch(getViewCron(false, {}, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(getViewCron(false, {}, true, 'Error Something when wrong, Please try again.'));
      });
  };
}
